import AdNetworkSignalEvent from "../../../models/ad-network/AdNetworkSignalEvent";
import type AdNetworkSignalFilters from "../../../models/ad-network/AdNetworkSignalFilters";
import AdNetworkSignalSubType from "../../../models/ad-network/AdNetworkSignalSubType";
import AdNetworkSignalTemplate from "../../../models/ad-network/AdNetworkSignalTemplate";
import SignalSource from "../../../models/core/SignalSource";
import SignalTemplatesManager from "../../../models/templates/SignalTemplatesManager";

const UNKNOWN_ALIAS = "unknown-signal";
const UNKNOWN_SIGNAL_TRANSLATABLE = { key: "Unknown signal" };

export default class AdNetworkSignalTemplatesManager extends SignalTemplatesManager<AdNetworkSignalFilters> {
    getEmptyTemplate(): Readonly<AdNetworkSignalTemplate> {
        return new AdNetworkSignalTemplate({
            filters: {
                adNetworkIds: [],
            },
            signalSource: SignalSource.Platform,
            alias: UNKNOWN_ALIAS,
            name: UNKNOWN_SIGNAL_TRANSLATABLE,
            description: UNKNOWN_SIGNAL_TRANSLATABLE,
        });
    }

    getDefaultTemplate(): Readonly<AdNetworkSignalTemplate> {
        return this.getEmptyTemplate();
    }

    getTemplates(): readonly AdNetworkSignalTemplate[] {
        return [
            new AdNetworkSignalTemplate({
                alias: "started-working-with-any-ad-network",
                name: { key: "si.signals.templates.ad-network.started-working.name" },
                description: {
                    key: "si.signals.templates.ad-network.started-working.description",
                },
                signalSource: SignalSource.Platform,
                filters: {
                    action: AdNetworkSignalEvent.StartedWorkingWith,
                    adNetworkIds: [],
                },
                signalSubType: AdNetworkSignalSubType.AddedAdNetworks,
            }),
            new AdNetworkSignalTemplate({
                alias: "stopped-working-with-any-ad-network",
                name: { key: "si.signals.templates.ad-network.stopped-working.name" },
                description: {
                    key: "si.signals.templates.ad-network.stopped-working.description",
                },
                signalSource: SignalSource.Platform,
                filters: {
                    action: AdNetworkSignalEvent.StoppedWorkingWith,
                    adNetworkIds: [],
                },
                signalSubType: AdNetworkSignalSubType.RemovedAdNetworks,
            }),
        ];
    }
}
